import * as moment from 'moment';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbAccordion, NgbModal, NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { ListFilter } from 'src/app/core/list-filter.model';
import { PDxTransmissionMethod } from 'src/app/core/PDxTransmissionMethod.enum';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { CloneService } from 'src/app/core/services/clone.service';
import { AssignEntityComponent } from '../assign-entity/assign-entity.component';
import { AssignedEntitySummary } from '../models/assigned-entity-summary.model';
import { VendorInformation } from '../models/vendor-information.model';
import { VendorDefaultsComponent } from '../vendor-defaults/vendor-defaults.component';
import { VendorPropertiesComponent } from '../vendor-properties/vendor-properties.component';
import { TableSorting } from 'src/app/core/tableSorting.component';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { VendorNoteComponent } from 'src/app/vendors/vendor-note/vendor-note.component';
import { VendorNoteInformation } from '../models/vendor-note-information.model';
import { UploadMasterComponent } from '../upload-master/upload-master.component';
import { DataFileUploadInformation } from '../models/data-file-upload-information.model';
import { VendorFileDetail, VendorFileInformation } from '../models/vendor-file-information.model';
import { VendorImportInformation } from '../models/vendor-import-information.model';
import { MbscDatepickerOptions } from '@mobiscroll/angular';
import { Moment } from 'moment';
import { VendorFileItemListComponent } from '../vendor-file-item-list/vendor-file-item-list.component';
import { RenameVendorFileComponent } from '../rename-vendor-file/rename-vendor-file.component';
import { VendorStatusListComponent } from '../vendor-status-list/vendor-status-list.component';

@Component({
  selector: 'app-vendor-detail',
  templateUrl: './vendor-detail.component.html',
  styles: [
  ]
})
export class VendorDetailComponent implements OnInit {
  @ViewChild(NgbAccordion) acc: NgbAccordion;

  vendorInfo: VendorInformation = new VendorInformation();
  nav: NgbNav;
  activeTab: string = 'files';
  PDxTransmissionMethod = PDxTransmissionMethod;
  assignedAccounts: PDxListItem<string>[] = [];
  notes: VendorNoteInformation[] = [];

  constructor(private ajax: ajaxCall,
    private modalService: NgbModal,
    private notifier: NotifierService,
    private cloneService: CloneService,
    private dirtyService: DirtyTrackingService,
    private router: Router,
    private location: Location,
    private confirmService: ConfirmService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    var vendorId = this.route.snapshot.params["vendorId"];
    this.activeTab = this.route.snapshot.params["tab"] || 'files';
    if (!vendorId) {
      this.editVendor();
    } else {
      this.loadVendor(vendorId);
    }
  }

  loadVendor(vendorId: string): void {
    this.ajax.MakeCall<VendorInformation>('/Vendor/Get', { vendorId: vendorId }).then((data) => {
      if (this.acc) {
        this.acc.collapseAll();
      }
      this.vendorInfo = data;
    }, () => { });
    this.ajax.MakeCall<PDxListItem<string>[]>('/Vendor/Accounts', { vendorId: vendorId }).then((data) => {
      this.assignedAccounts = data;
      for (var i = 0; i < this.assignedAccounts.length; i++) {
        if (i >= this.filter.length) {
          this.filter.push(new VendorAccountListFilter(vendorId, this.assignedAccounts[i].value));
        } else if (this.filter[i].accountId != this.assignedAccounts[i].value) {
          if (this.filter.filter(x => x.accountId == this.assignedAccounts[i].value).length > 0) {
            this.filter[i] = this.filter.filter(x => x.accountId == this.assignedAccounts[i].value)[0];
          } else {
            this.filter[i] = new VendorAccountListFilter(vendorId, this.assignedAccounts[i].value);
          }
        }

        if (i >= this.entityResults.length) {
          this.entityResults.push({ data: [], recordsFiltered: 0, recordsTotal: 0 });
        } else {
          this.entityResults[i].data = [];
        }

        this.loadList(i, true);
      }
    }, () => { this.assignedAccounts = []; });
    this.getNotes(vendorId);
    this.fileListFilter = new VendorFileListFilter(vendorId);
    this.loadFiles();
    this.fImportFilter = new VendorImportListFilter(vendorId, false);
    this.mImportFilter = new VendorImportListFilter(vendorId, true);
    this.loadFormularyImportList();
    this.loadMasterImportList();
  }

  viewStatusList(): void {
    const modal = this.modalService.open(VendorStatusListComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });

    modal.componentInstance.vendorId = this.vendorInfo.vendorId;

    modal.result.then(() => { }, () => { });
  }

  getNotes(vendorId: string): void {
    this.ajax.MakeCall<VendorNoteInformation[]>('/Vendor/Notes', { vendorId: vendorId }).then((data) => {
      this.notes = data;
    }, () => { });
  }

  editVendor(): void {
    const modal = this.modalService.open(VendorPropertiesComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.vendorInfo = this.cloneService.deepClone(this.vendorInfo);
    modal.result.then((vendorId: string) => {
      this.loadVendor(vendorId);

      var pathArray = ['/manage/vendor', vendorId, this.activeTab];
      var url = this.router.createUrlTree(pathArray).toString();
      this.location.go(url);
    }, () => {
      if (!this.vendorInfo.vendorId) {
        this.router.navigate(['/manage/vendors']);
      }
    });
  }

  viewDefaults(): void {
    const modal = this.modalService.open(VendorDefaultsComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.vendorId = this.vendorInfo.vendorId;
    modal.result.then(() => { }, () => { });
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    var pathArray = ['/manage/vendor', this.vendorInfo.vendorId, changeEvent.nextId];
    var url = this.router.createUrlTree(pathArray).toString();
    this.location.go(url);
  }

  assignEntity(entityId: string): void {
    const modal = this.modalService.open(AssignEntityComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.vendorId = this.vendorInfo.vendorId;
    modal.componentInstance.entityId = entityId;
    modal.result.then((accountIds: string[]) => {
      // reload the list for the account
      if (accountIds.filter(aId => this.assignedAccounts.filter(aa => aa.value == aId).length == 0).length != 0) {
        this.loadVendor(this.vendorInfo.vendorId);
      } else {
        for (var i = 0; i < this.assignedAccounts.length; i++) {
          if (accountIds.filter(aId => aId == this.assignedAccounts[i].value).length > 0) {
            this.loadList(i, entityId === null);
          }
        }
      }
    }, () => { });
  }

  filter: VendorAccountListFilter[] = [];
  entityResults: DataTablesResponse<AssignedEntitySummary>[] = [];

  toggleAccordion(idx: number): void {
    var panelId = 'account-panel-' + idx;
    if (this.acc.isExpanded(panelId)) {
      this.acc.collapse(panelId);
    } else {
      this.acc.expand(panelId);
    }
  }

  loadList = (idx: number, reset: boolean = false) => {
    if (reset) {
      this.filter[idx].page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<AssignedEntitySummary>>('/Vendor/FullEntityList', this.filter[idx]).then(results => {
      this.entityResults[idx] = results;
    }, () => { });
  }

  private filterTimeout: NodeJS.Timeout;
  changeSearchFilter(idx: number, now: boolean): void {
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }

    if (now) {
      this.loadList(idx, true);
    } else {
      this.filterTimeout = setTimeout(() => { this.loadList(idx, true); }, 500);
    }
  }

  removeAssignment(idx: number, entityId: string): void {
    this.confirmService.delete('Remove Assignment', 'Are you sure that you want to remove this entity?', 'Remove').then(() => {
      this.ajax.MakeCall('/Vendor/RemoveEntity', { vendorId: this.vendorInfo.vendorId, entityId: entityId }).then(() => {
        if (this.entityResults[idx].recordsTotal == 1) {
          this.loadVendor(this.vendorInfo.vendorId);
        } else {
          this.loadList(idx, true);
        }
      }, () => { });
    }, () => { });
  }

  removeAccount(accountId: string): void {
    this.confirmService.delete('Remove Account', 'Are you sure that you want to remove this account and all associated entities?', 'Remove').then(() => {
      this.ajax.MakeCall('/Vendor/RemoveAccount', { vendorId: this.vendorInfo.vendorId, accountId: accountId }).then(() => {
        this.loadVendor(this.vendorInfo.vendorId);
      }, () => { });
    }, () => { });
  }

  viewNote(noteInfo: VendorNoteInformation): void {
    const modal = this.modalService.open(VendorNoteComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.noteInfo = this.cloneService.deepClone(noteInfo) || { vendorId: this.vendorInfo.vendorId };
    modal.result.then(() => {
      this.getNotes(this.vendorInfo.vendorId);
    }, () => { });
  }

  removeNote(noteId: string): void {
    this.confirmService.delete('Remove Note', 'Are you sure that you want to remove this note?', 'Remove').then(() => {
      this.ajax.MakeCall('/Vendor/RemoveNote', { noteId: noteId }).then(() => {
        this.getNotes(this.vendorInfo.vendorId);
      }, () => { });
    }, () => { });
  }

  downloadTemplate(fileType: string): void {
    window.open('/Template/' + fileType);
  }

  downloadFile(vendorFileId: string): void {
    window.open('/VendorFile/' + vendorFileId);
  }

  uploadMaster(vendorFileId: string, isMaster: boolean, isAddUpdate: boolean): void {
    const modal = this.modalService.open(UploadMasterComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });

    modal.componentInstance.uploadInfo = {
      vendorId: this.vendorInfo.vendorId,
      vendorFileId: vendorFileId,
      isMaster: isMaster,
      isAddUpdate: isAddUpdate,
    };

    modal.result.then(() => {
      this.loadFiles();
      if (isMaster) {
        this.loadMasterImportList();
      } else {
        this.loadFormularyImportList();
      }
    }, () => { });
  }

  renameFile(vendorFileId: string, fileName: string): void {
    const modal = this.modalService.open(RenameVendorFileComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });

    modal.componentInstance.uploadInfo = {
      vendorId: this.vendorInfo.vendorId,
      vendorFileId: vendorFileId,
      commonName: fileName
    };

    modal.result.then(() => {
      this.loadFiles();
      this.loadMasterImportList();
    }, () => { });
  }

  fileListFilter: VendorFileListFilter;
  fileInfo: VendorFileInformation;
  loadFiles(): void {
    this.ajax.MakeCall<VendorFileInformation>('/Vendor/Files', this.fileListFilter).then(results => {
      this.fileInfo = results;
    }, () => { });
  }

  fImportFilter: VendorImportListFilter;
  mImportFilter: VendorImportListFilter;
  formularyImports: DataTablesResponse<VendorImportInformation>;
  masterImports: DataTablesResponse<VendorImportInformation>;
  loadFormularyImportList = (): void => {
    if (this.fImportFilter.dateRange) {
      if ((this.fImportFilter.dateRange.length > 0) && (this.fImportFilter.dateRange[0])) {
        this.fImportFilter.startDate = this.fImportFilter.dateRange[0].clone().utc().valueOf();
      } else {
        this.fImportFilter.startDate = null;
      }
      if ((this.fImportFilter.dateRange.length > 1) && (this.fImportFilter.dateRange[1])) {
        this.fImportFilter.endDate = this.fImportFilter.dateRange[1].clone().utc().valueOf();
      } else {
        this.fImportFilter.endDate = null;
      }
    } else {
      this.fImportFilter.startDate = null;
      this.fImportFilter.endDate = null;
    }
    this.ajax.MakeCall<DataTablesResponse<VendorImportInformation>>('/Vendor/Imports', this.fImportFilter).then(results => {
      this.formularyImports = results;
    }, () => { });
  }

  loadMasterImportList = (): void => {
    if (this.mImportFilter.dateRange) {
      if ((this.mImportFilter.dateRange.length > 0) && (this.mImportFilter.dateRange[0])) {
        this.mImportFilter.startDate = this.mImportFilter.dateRange[0].clone().utc().valueOf();
      } else {
        this.mImportFilter.startDate = null;
      }
      if ((this.mImportFilter.dateRange.length > 1) && (this.mImportFilter.dateRange[1])) {
        this.mImportFilter.endDate = this.mImportFilter.dateRange[1].clone().utc().valueOf();
      } else {
        this.mImportFilter.endDate = null;
      }
    } else {
      this.mImportFilter.startDate = null;
      this.mImportFilter.endDate = null;
    }
    this.ajax.MakeCall<DataTablesResponse<VendorImportInformation>>('/Vendor/Imports', this.mImportFilter).then(results => {
      this.masterImports = results;
    }, () => { });
  }

  viewItems(vendorFile: VendorFileDetail, isMaster: boolean): void {
    const modal = this.modalService.open(VendorFileItemListComponent, { size: 'fullscreen' });

    modal.componentInstance.fileInfo = vendorFile;
    modal.componentInstance.isMaster = isMaster;

    modal.result.then(() => { }, () => { });
  }

  refToMoment = moment;
  fDateOptions: MbscDatepickerOptions = {
    controls: ['calendar'],
    select: 'range',
    theme: 'ios',
    themeVariant: 'light',
    returnFormat: 'moment',
    dateFormat: 'M/D/YYYY',
    max: new Date(),
    onChange: () => {
      this.loadFormularyImportList();
    }
  };
  mDateOptions: MbscDatepickerOptions = {
    controls: ['calendar'],
    select: 'range',
    theme: 'ios',
    themeVariant: 'light',
    returnFormat: 'moment',
    dateFormat: 'M/D/YYYY',
    max: new Date(),
    onChange: () => {
      this.loadMasterImportList();
    },
  };

  deleteFile(vendorFileId: string): void {
    this.confirmService.delete('Remove File', 'Are you sure that you want to remove this file?').then(() => {
      this.ajax.MakeCall('/Vendor/RemoveFile', { vendorFileId: vendorFileId }).then(() => {
        this.loadFiles();
      }, () => { });
    }, () => { });

  }
}

class VendorAccountListFilter extends ListFilter {
  constructor(v: string, a: string) {
    super(25, 'Entity', 'asc');
    this.vendorId = v;
    this.accountId = a;
  }
  nameFilter?: string;
  vendorId: string;
  accountId: string;
}

class VendorFileListFilter extends ListFilter {
  constructor(v: string) {
    super(0, 'Name', 'asc');
    this.vendorId = v;
  }
  vendorId: string;
}

class VendorImportListFilter extends ListFilter {
  vendorId: string;
  isMaster: boolean;
  dateRange: Moment[] = [];
  startDate: number;
  endDate: number;
  constructor(v: string, m: boolean) {
    super(10, 'Date', 'desc');
    this.vendorId = v;
    this.isMaster = m;
  }
}